import type { BulkEditSection } from './bulk-edit-section.types';
import type { BulkSelectionPayload } from './bulk-edit.models';

export interface BulkEditPropertyDialogData {
  section: BulkEditSection;
  selectedCount: number;
  matchingCount?: number;
  selectionPayload: BulkSelectionPayload;
  resourcePath: string;
}

export interface BulkJobToastData {
  jobId: string;
  gatewayJobId?: string;
  propertyLabelKey?: string;
  total: number;
  queueName: string;
}

export type BulkEditJobDescriptor = BulkJobToastData;
export type BulkEditPropertyDialogResult = BulkJobToastData;
